module.exports = __webpack_public_path__ + "img/upload.cdee80c7.svg";